import type { FC } from 'react'
import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import LogoTiles from '@segment/templates/LogoTiles'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `Need something else?`,
  description: `Submit a ticket to our support team for additional help.`,
}

const button = {
  text: `Open a ticket`,
  href: `https://segment.com/help/contact/`,
}

const NeedSomethingElse: FC = () => {
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <Content>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
        <StyledButton
          size="large"
          color="primary"
          variant="filled"
          tag="a"
          href={getAbsoluteUrl(button.href, pageConfig)}
        >
          {button.text}
        </StyledButton>
      </Content>
      <LogoTiles />
    </Wrapper>
  )
}

const Wrapper = styled.section`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 40px;
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding-top: 160px;
  }
`

const Content = styled.div`
  display: grid;
  justify-items: center;
  row-gap: 40px;
  padding: 0 24px;
`

const StyledButton = styled(Button)`
  width: 100%;
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    width: unset;
  }
`

export default NeedSomethingElse
